module.exports = __webpack_public_path__ + "static/media/YM49_2.61d4f8e5.jpg";